import { create } from "zustand";
import { MissionData } from "../../../interfaces/mission";
import { CommentaryRefused } from "../../../interfaces/commentaryInterface";
import { IRequest } from "../../../interfaces/requestsInterface";

type CustomerRequestState = {
    requests: IRequest[];
    setRequests: (requests: IRequest[]) => void;

    filteredRequests: IRequest[];
    setFilteredRequests: (filteredRequests: IRequest[]) => void;

    dataMission: MissionData;
    setDataMission: (dataMission: MissionData) => void;

    requestIdCustomer: number;
    setRequestIdCustomer: (resquestIdCustomer: number) => void;

    openDetailsCustomer: boolean;
    setOpenDetailsCustomer: (openDetailsCustomer: boolean) => void;

    request: any;
    setRequest: (request: any) => void;
    
    choiceTab: string;
    setChoiceTab: (choiceTab: string) => void;

    updateRequestByClient: boolean;
    setUpdateRequestByClient: (updateRequestByClient: boolean) => void;

    commentsRefused: CommentaryRefused[];
    setCommentsRefused: (commentsRefused: CommentaryRefused[]) => void;

    displayAllRequests: boolean;
    setDisplayAllRequests: (displayAllRequests: boolean) => void;
}

export const useCustomerRequestsStore = create<CustomerRequestState>(
    (set) => ({
        requests: [],
        setRequests: (requests: IRequest[]) => set(() => ({ 
            requests: requests,
            filteredRequests: requests 
        })),
        
        filteredRequests: [],
        setFilteredRequests: (filteredRequests: IRequest[]) => set(() => ({ filteredRequests: filteredRequests })),
        
        dataMission: {} as MissionData,
        setDataMission: (dataMission: MissionData) => set(() => ({ dataMission: dataMission })),
    
        requestIdCustomer: 0,
        setRequestIdCustomer: (requestIdCustomer: number) => set(() => ({ requestIdCustomer: requestIdCustomer})),
    
        openDetailsCustomer: false,
        setOpenDetailsCustomer: (openDetailsCustomer: boolean) => set(() => ({ openDetailsCustomer: openDetailsCustomer })),
    
        request: {} ,
        setRequest: (request: any) => set({ request: request }),
  
        choiceTab: "Documents",
        setChoiceTab: (choiceTab: string) => set(() => ({ choiceTab: choiceTab })),
    
        updateRequestByClient: false,
        setUpdateRequestByClient: (updateRequestByClient: boolean) => set(() => ({ updateRequestByClient: updateRequestByClient })),
    
        commentsRefused: [],
        setCommentsRefused: (commentsRefused: CommentaryRefused[]) => set(() => ({ commentsRefused: commentsRefused })),

        displayAllRequests: false,
        setDisplayAllRequests: (displayAllRequests) => set({ displayAllRequests: displayAllRequests }),    
    })
);